import React from 'react';
import { NavLink, Outlet, Navigate, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, Building2, LogOut, Gem
} from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import Logo from '../common/Logo';
import './platform.css';

// Platform shell — separate from the per-school admin layout because the
// owner operates across every tenant and shouldn't see a school switcher.
const PlatformLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'superadmin') return <Navigate to="/dashboard" replace />;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="pf-app">
      <aside className="pf-sidebar">
        <div className="pf-brand">
          <Logo size={30} showWordmark wordmarkSize={16} />
          <span className="pf-brand-chip">
            <Gem size={11} /> OWNER
          </span>
        </div>

        <nav className="pf-nav">
          <NavLink to="/platform" end className={({ isActive }) => `pf-link ${isActive ? 'active' : ''}`}>
            <LayoutDashboard size={16} /> Overview
          </NavLink>
          <NavLink to="/platform/schools" className={({ isActive }) => `pf-link ${isActive ? 'active' : ''}`}>
            <Building2 size={16} /> Schools
          </NavLink>
        </nav>

        <div className="pf-sidebar-foot">
          <div className="pf-user">
            <div className="pf-avatar">
              {(user.firstName || 'O').charAt(0)}{(user.lastName || '').charAt(0)}
            </div>
            <div className="pf-user-meta">
              <div className="pf-user-name">{user.firstName} {user.lastName}</div>
              <div className="pf-user-role">Platform owner</div>
            </div>
          </div>
          <button className="pf-logout" onClick={handleLogout}>
            <LogOut size={14} /> Log out
          </button>
        </div>
      </aside>

      <main className="pf-main">
        <Outlet />
      </main>
    </div>
  );
};

export default PlatformLayout;
